export { default } from "./products-tab";
